module.exports = __webpack_public_path__ + "static/media/polygon_1.34e91407.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/polygon_1.svg
// module id = 892
// module chunks = 7